export default __webpack_public_path__ + "static/media/lucas.c42040a2.png";